import { RenderingDetails } from "@swiggy-private/cart-types";

export enum DELIVERY_SECTION_ELEMENT {
    DELIVERY_TYPE = "DELIVERY_SPEED",
    TIP = "CARD_INFORMATION",
    INSTRUCTIONS = "DELIVERY_INSTRUCTIONS",
    SELF_DELIVERY = "SELF_DELIVERY_INSTRUCTIONS",
}

export type DeliveryTabOption = {
    id: DELIVERY_SECTION_ELEMENT;
    label: string;
    isSelected?: boolean;
    meta: RenderingDetails;
    ariaLabel?: string;
};
